import React from 'react';
// Import Swiper React components
import {Swiper, SwiperSlide} from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
//import './PromoBanners.css';

// import required modules
import {Pagination} from 'swiper/modules';
import {eventEmitter} from "../../common/baseData";

function PromoBannersMobile(props) {
  const {items} = props;

  return (
    <>
      {Array.isArray(items) && items.length > 0 && (
        <>
          <div
            className={`relative flex items-center w-full h-full overflow-hidden pl-5`}
            onClick={event => {
              event.stopPropagation();
            }}>
            <Swiper
              modules={[Pagination]}
              loop={true}
              observer={true}
              observeParents={true}
              updateOnWindowResize={true}
              pagination={{
                type: 'progressbar',
                el: '#promo-banners-mobile-pagination',
                progressbarFillClass: `absolute left-0 top-0 bg-blue-primary w-full h-full origin-top-left`,
              }}
              spaceBetween={8}
              breakpoints={{
                320: {slidesPerView: 2.3},
                480: {slidesPerView: 2.5},
                600: {slidesPerView: 3},
                1024: {slidesPerView: 3.5},
                1279: {slidesPerView: 4},
              }}
              className={''}>
              {items.map((banner, index) => (
                <SwiperSlide key={`promo-banner-${index}`}>
                  <a href={banner.link} {...(banner.attribute_rel && { rel: banner.attribute_rel })}
                     onClick={() => {eventEmitter.emit('showLoader')}}
                     className={`block h-full rounded-[14px] overflow-hidden`}>
                    <picture>
                      {banner.picture?.webp && <source srcSet={banner.picture.webp} type="image/webp"/>}
                      {banner.picture?.avif && <source srcSet={banner.picture.avif} type="image/avif"/>}
                      <img src={banner.picture.orig}
                           loading={index === 0 ? 'eager' : 'lazy'}
                           decoding="async"
                           fetchpriority={index === 0 ? 'high' : 'low'}
                           width={banner.picture?.width}
                           height={banner.picture?.height}
                           alt={banner.title}
                           className='h-full w-full'/>
                    </picture>
                  </a>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
          <div id={`promo-banners-mobile-pagination`}
               className={`relative mx-5 mt-2 w-[calc(100%-40px)] h-1 !bg-grey-10 z-2 desktop:mt-2`}/>
        </>
      )
      }
    </>
  );
}

export default PromoBannersMobile;